// src/layouts/MainLayout.js
import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import CTASection from '../components/CTASection';
const MainLayout = ({ children }) => {
  return (
    <div>
      <Navbar />

        <main>{children}</main>
        
      <CTASection />
      {/* Footer is always visible */}
      <Footer />
    </div>
  );
};

export default MainLayout;
